import React, { useState } from "react";
import AddCharge from "../AddEdit/AddCharge";
import EditCharge from "../AddEdit/EditCharge";

const ChargesTab = () => {
  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  return (
    <>
      <div className="row border-bottom-2 pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="row">
            <div className="table-responsive ">
              <table className="table table-striped table-sm">
                <thead>
                  <tr className="header-group">
                    <th colspan="1">Particulars</th>
                    <th colspan="6">Revenue</th>
                    <th colspan="7">Cost</th>
                  </tr>
                  <tr>
                    <th scope="col">Charge Head</th>
                    <th scope="col">Curr</th>
                    <th scope="col">Basis</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Amount (INR)</th>
                    <th scope="col">Receivable</th>
                    <th scope="col">Curr</th>
                    <th scope="col">Basis</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Amount (INR)</th>
                    <th scope="col">Payable</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                      <div className="dropdown table-action">
                        <a
                          className="action-icon"
                          data-bs-toggle="dropdown"
                          href="#"
                        >
                          <i className="fa fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <div
                            className="dropdown-item cursor-pointer"
                            onClick={handleShowEdit}
                          >
                            <i className="ti ti-edit text-blue me-2" /> Edit
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>

      <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />
      <EditCharge showAdd={showEdit} handleCloseAdd={handleCloseEdit} />
    </>
  );
};

export default ChargesTab;
